import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box } from "@material-ui/core";

import RegionsMap, { pointerInfoEmpty } from "components/visuals/maps/RegionsMap";

import TotalSalesGrowthByRegionMapPopup from "./TotalSalesGrowthByRegionMapPopup";

import { selectMapboxConfiguration } from "modules/siteConfiguration/siteConfigurationSlice";
import { operations, selectors } from "modules/customer/insights/performance/sales/regionalGrowthBreakdown";

const TotalSalesGrowthByRegion = () => {
    const dispatch = useDispatch();
    const mapboxConfiguration = useSelector(selectMapboxConfiguration);
    const totalSalesGrowthByRegion = useSelector(state => selectors.totalSalesGrowthByRegion(state));
    const { loading, error, regionsGrowth } = totalSalesGrowthByRegion;
    const regions = regionsGrowth.map(r => ({
        code: r.regionId,
        colourGroup: r.group
    }))
    .filter(r => r.code != null && r.colourGroup != null);
    const [hoverInfo, setHoverInfo] = React.useState(pointerInfoEmpty);
    const [clickInfo, setClickInfo] = React.useState(pointerInfoEmpty);

    React.useEffect(() => {
        dispatch(operations.getTotalSalesGrowthByRegion());
    }, [dispatch]);

    const handleClick = (pointerInfo) => {
        setClickInfo(pointerInfo);
        dispatch(operations.setSelectedRegion(pointerInfo.regionCode ?? ""));
    };

    return (
        <Box data-cy="total-sales-growth-by-region">
            <RegionsMap
                loading={loading}
                error={error}
                title={"Year-on-year revenue growth (%) by region"}
                mapboxAccessToken={mapboxConfiguration.accessToken}
                mapboxBaseMapStyle={mapboxConfiguration.baseMapStyle}
                mapboxRegionsTilesetId={mapboxConfiguration.regionsTilesetId}
                mapboxRegionsTilesetUrl={mapboxConfiguration.regionsTilesetUrl}
                regions={regions}
                onHover={setHoverInfo}
                onClick={handleClick}
                downloadData={regionsGrowth}
            >
                <TotalSalesGrowthByRegionMapPopup
                    hoverInfo={hoverInfo}
                    clickInfo={clickInfo}
                    regions={regionsGrowth}
                />
            </RegionsMap>
        </Box>
    );
};

export default TotalSalesGrowthByRegion;
